import { InputAdornment, TextField } from '@mui/material'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { PercentageFormFieldProps } from '@zealth/core/formFields/types'
import { percentToRatio, ratioToPercent } from '@zealth/core/math/percentage'
import { Percent } from 'lucide-react'
import { NumericFormat } from 'react-number-format'

const PercentageAdornment = () => (
  <InputAdornment
    position="end"
    sx={{
      color: 'text.primary',
      opacity: 0.2,
    }}
  >
    <Percent className="size-6" data-testid="PercentageAdornmentIcon" />
  </InputAdornment>
)

const decimalScale = 2

export const PercentageFormField = ({
  label,
  placeholder,
  optional,
}: PercentageFormFieldProps) => {
  const field = useFieldContext<number | null>()

  return (
    <NumericFormat
      customInput={TextField}
      fullWidth
      label={label}
      placeholder={placeholder}
      required={!optional}
      allowNegative={false}
      allowLeadingZeros={false}
      decimalScale={decimalScale}
      value={ratioToPercent(field.state.value)}
      error={field.state.meta.errors.length > 0}
      helperText={field.state.meta.errors[0]?.message ?? ' '}
      onBlur={field.handleBlur}
      onValueChange={values =>
        field.handleChange(percentToRatio(values.floatValue))
      }
      slotProps={{
        input: {
          endAdornment: <PercentageAdornment />,
        },
      }}
    />
  )
}
